import { useEffect } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router';

import { useIsFirstRenderRef } from '#/hooks/useIsFirstRenderRef';
import { useIsInEmbedSearchWidget } from '#/modules/embedSearchWidget/hooks/useIsInEmbedSearchWidget';
import { trackEvent } from '#/utils/analytics/track/trackEvent';
import { highlightElement } from '#/utils/highlightElement';

export function RenderingClientLocationHooks() {
  const location = useLocation();
  const navigationType = useNavigationType();

  const { isInEmbedSearchWidget } = useIsInEmbedSearchWidget();
  const { isFirstRenderRef } = useIsFirstRenderRef();

  useEffect(() => {
    if (
      !isFirstRenderRef.current &&
      navigationType !== NavigationType.Replace
    ) {
      trackEvent('JS Page View');
    }
  }, [isFirstRenderRef, navigationType]);

  useEffect(() => {
    // When clicking a href=#... we want to always scroll to it even if the same hash was already set
    if (location.hash && navigationType === NavigationType.Push) {
      const target = document.getElementById(location.hash.substring(1));
      if (target) highlightElement(target);
    }
  }, [isInEmbedSearchWidget, location.hash, navigationType]);

  return null;
}
